// extracted by mini-css-extract-plugin
export var noSpinners = "_sj-6";
export var percentageInput = "_sj-7";
export var variantColor1 = "_sj-0";
export var variantColor2 = "_sj-1";
export var variantColor3 = "_sj-2";
export var variantColor4 = "_sj-3";
export var variantColor5 = "_sj-4";
export var variantColor6 = "_sj-5";